import { render, staticRenderFns } from "./RedFlags.vue?vue&type=template&id=188056b5&"
import script from "./RedFlags.vue?vue&type=script&lang=js&"
export * from "./RedFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports